export class DownloadFileService {
  constructor () {
    'ngInject';
  }

  downloadFromResponse(response, type, filename) {
    var blob = new Blob([response.data], {type});
    var file = (window.URL || window.webkitURL).createObjectURL(blob);

    if(window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else{
      var link = document.createElement('a');
      link.href = file;
      if(link.download != undefined) {
        link.download = filename;
      }
      if(document.createEvent) {
        var e = document.createEvent('MouseEvents');
        e.initEvent('click', true, true);
        link.dispatchEvent(e);
        return true;
      }
    }
  }
}
